"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_count_1 = require("dyna-count");
exports.COMMAND_ping = "ping";
exports.COMMAND_pong = "pong";
exports.commandPingPong = {
    executionTimeout: 1000,
    execute: function (_a) {
        var message = _a.message, isActive = _a.isActive, reply = _a.reply, next = _a.next;
        var args = __assign({ pongsCount: 1, pongDelay: 0, pongCommandInData: false, pongArgsInData: false, pongDataInData: false, pongHeadersInData: false }, message.args);
        dyna_count_1.count(args.pongsCount || 1)
            .for(function (index) {
            setTimeout(function () {
                if (!isActive())
                    return;
                reply({
                    command: exports.COMMAND_pong,
                    updateReplyOfArgs: true,
                    updateReplyOfData: true,
                    data: {
                        serverTime: new Date,
                        command: args.pongCommandInData ? message.command : undefined,
                        args: args.pongArgsInData ? message.args : undefined,
                        data: args.pongDataInData ? message.data : undefined,
                        headers: args.pongHeadersInData ? message.headers : undefined,
                        pongCount: index + 1,
                        requestMessageDynaInfo: message.dynaNodeInfo,
                        yourIpAddress: message.dynaNodeInfo.fromIpAddress,
                    },
                });
            }, (args.pongDelay || 0) * (index + 1));
        });
        next();
    },
};
//# sourceMappingURL=pingPong.js.map